import styled, { css } from 'styled-components';
import { colors, media, remCalc, layout } from '@prisjakt/ui-base';
import Dropdown from '@prisjakt/ui-dropdown';

import AdContainerComponent from '../../../../components/ads';

type AdvertProps = {
  withPosition?: boolean;
};

const compensateForPadding = remCalc(layout.gridColumnGutter.small.value / 2);

export const AdContainer = styled(AdContainerComponent)`
  @media screen and (max-width: 340px) {
    margin-left: -${compensateForPadding};
    margin-right: -${compensateForPadding};
  }
`;

export const PlaceholderRow = styled.div`
  border-bottom: 1px solid ${colors.lightGray1};
  display: flex;
  height: 64px;
  padding: 15px 0;
  width: 100%;
`;

const PlaceholderBox = styled.div`
  background: ${colors.lightGray1};
  border-radius: 3px;
  height: 100%;
`;

export const ShopPlaceholder = styled(PlaceholderBox)`
  margin-right: 10%;
  flex: 0 1 150px;
`;

export const StockAndPricePlaceholder = styled(PlaceholderBox)`
  margin-left: auto;
  flex: 0 1 150px;
`;

export const CallToActionPlaceholder = styled(PlaceholderBox)`
  flex: 0 0 25px;
  margin-left: 10%;
  ${media.largeUp`
    margin-right: 15px;
    flex: 0 0 130px;
  `};
`;

export const PriceRowWrapper = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
`;

export const PriceRowTable = styled.table`
  width: 100%;
  border-spacing: 0;
  table-layout: fixed;
  ${media.mediumDown`
    thead th > div {
      height: 0;
      visibility: hidden;
    }
  `}
`;

export const PriceRowTableHeadExpand = styled.th`
  width: 50px;
  ${media.smallOnly`
    width: 35px;
  `}
`;
export const PriceRowTableHeadStore = styled.th`
  width: 108px;
`;
export const PriceRowTableHeadProduct = styled.th`
  width: auto;
`;
export const PriceRowTableHeadStock = styled.th`
  width: 10%;
`;
export const PriceRowTableHeadPrice = styled.th`
  width: 18%;
  ${media.mediumDown`
    width: 25%;
  `}
`;
export const PriceRowTableHeadClickOut = styled.th`
  width: 200px;
  ${media.mediumDown`
    width: 55px;
  `}
  ${media.smallOnly`
    width: 40px;
  `}
`;

export const Information = styled.div`
  border-top: 1px solid ${colors.lightGray1};
  color: ${colors.darkGray2};
  font-size: ${remCalc(13)};
  font-style: italic;
  padding-top: ${remCalc(10)};
  padding-bottom: ${remCalc(10)};
`;

export const AdvertTableRowElement = styled.tr<AdvertProps>`
  width: 100%;
  border-bottom: none;

  ${p =>
    p.withPosition &&
    css`
      order: 3;
    `};
`;

export const NoPrices = styled.div`
  margin-top: ${remCalc(20)};
  border: none;

  div {
    margin-top: ${remCalc(10)};
  }

  a {
    margin-top: ${remCalc(10)};
    color: ${p => p.theme.text.callToAction};
  }
`;

export const PriceFilter = styled(Dropdown)`
  /* Merge dropdown border with the divider when expanded */
  margin-left: -1px;

  &.ui-dropdown {
    &-expanded {
      .ui-dropdown--header {
        margin-bottom: -1px;
        border-bottom: 1px solid ${colors.white};
        /* Have to end up on top of the content */
        z-index: 2;
      }
    }

    .ui-dropdown--sub-content {
      padding-top: ${remCalc(10)};
      padding-bottom: ${remCalc(10)};
      width: 200px;
      right: 0;
      border-top: 1px solid ${colors.lightGray2};
    }

    /* On mobile, we only want the three vertical dots, not the arrow. */
    ${media.smallOnly`
        .pj-ui-icon--arrow {
          display: none;
        }
  `}
  }

  /* Style the dropdown toggle as 'selected'.
    Not a good way to achieve this, but necessary until
    we refactor the Dropdown component. */
  .ui-dropdown--toggle-button,
  .ui-dropdown--title-expanded {
    color: ${p => p.theme.text.callToAction};
    font-weight: bold;

    &:hover {
      color: ${p => p.theme.text.callToActionHover};

      .ui-dropdown--title-expanded {
        color: ${p => p.theme.text.callToActionHover};
      }

      svg path {
        fill: ${p => p.theme.icons.callToActionHover};
      }
    }
  }
`;

export const OnlyMobile = styled.span`
  ${media.smallOnly`
    display: inherit;
  `}

  ${media.mediumUp`
  display: none;
  `}
`;

export const OnlyDesktop = styled.span`
  ${media.smallOnly`
    display: none;
  `}

  ${media.mediumUp`
    display: inherit;
  `}
`;

export const Header = styled.div`
  .pj-ui-panel-header--title {
    display: block;
    margin-bottom: ${remCalc(10)};
  }

  .pj-ui-panel-header--child-container-only-children {
    justify-content: flex-end;
  }
`;
